import { render, staticRenderFns } from "./ModalAddPrivilegeDetail.vue?vue&type=template&id=0639d1b2&scoped=true"
import script from "./ModalAddPrivilegeDetail.vue?vue&type=script&lang=js"
export * from "./ModalAddPrivilegeDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPrivilegeDetail.vue?vue&type=style&index=0&id=0639d1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639d1b2",
  null
  
)

export default component.exports